import { USER } from '../actions';

const initialState = {
    purchase: {
        filter: 'ทั้งหมด',
        isFetching: false,
        data: null,
        error: false,
        dataError: null
    },
    makeReturn: {
        dialogNotSelect: false,
        dialogSelectRemark: false,
        dialogOverMaxFile: false,
        dialogFileTypeNotSupport: false,
        dialogFileRequired: false,
        isFetching: false,
        data: null,
        error: false,
        dataError: null,
        dialogSubmitError: false,
        submitFetching: false
    },
    refund: {
        filter: 'ทั้งหมด',
        isFetching: false,
        data: null,
        error: false,
        dataError: null
    },
    voucher: {
        isFetching: false,
        data: [],
        error: false,
        dataError: null,
        filter: 'ทั้งหมด'
    }
};

export default (state = initialState, { type, payload, error }) => {
    switch (type) {
        case USER.ORDER_FILTER_CHANGE:
            return { ...state, purchase: { ...state.purchase, filter: payload } };

        case USER.GET_PURCHASE_ORDER_BY_USER_ID_PENDING:
            return { ...state, purchase: { ...state.purchase, isFetching: true, data: null, error: false, dataError: null } };
        case USER.GET_PURCHASE_ORDER_BY_USER_ID_SUCCESS:
            return { ...state, purchase: { ...state.purchase, isFetching: false, data: payload } };
        case USER.GET_PURCHASE_ORDER_BY_USER_ID_FAILED:
            return { ...state, purchase: { ...state.purchase, isFetching: false, error: true, dataError: error } };

        case USER.GET_PURCHASE_ORDER_BY_ORDER_ID_PENDING:
            return {
                ...state,
                makeReturn: { ...state.makeReturn, isFetching: true, data: null, error: false, dataError: null }
            };

        case USER.GET_PURCHASE_ORDER_BY_ORDER_ID_SUCCESS:
            return { ...state, makeReturn: { ...state.makeReturn, isFetching: false, data: payload } };

        case USER.GET_PURCHASE_ORDER_BY_ORDER_ID_FAILED:
            return { ...state, makeReturn: { ...state.makeReturn, isFetching: false, error: true, dataError: error } };

        case USER.REFUND_FILTER_CHANGE:
            return { ...state, refund: { ...state.refund, filter: payload } };

        case USER.GET_REFUND_BY_CUSTOMER_ID_PENDING:
            return { ...state, refund: { ...state.refund, isFetching: true, error: false, dataError: null } };

        case USER.GET_REFUND_BY_CUSTOMER_ID_SUCCESS:
            return { ...state, refund: { ...state.refund, isFetching: false, data: payload } };

        case USER.GET_REFUND_BY_CUSTOMER_ID_FAILED:
            return { ...state, refund: { ...state.refund, isFetching: false, error: true, dataError: error } };

        case USER.SUBMIT_RETURN_FORM_DATA_PENDING:
            return { ...state, makeReturn: { ...state.makeReturn, submitFetching: true } };

        case USER.SUBMIT_RETURN_FORM_DATA_SUCCESS:
            return { ...state, makeReturn: { ...state.makeReturn, submitFetching: false } };

        case USER.SUBMIT_RETURN_FORM_DATA_FAILED:
            return { ...state, makeReturn: { ...state.makeReturn, submitFetching: false } };

        case USER.OPEN_DIALOG_NOT_SELECT:
            return { ...state, makeReturn: { ...state.makeReturn, dialogNotSelect: true } };

        case USER.CLOSE_DIALOG_NOT_SELECT:
            return { ...state, makeReturn: { ...state.makeReturn, dialogNotSelect: false } };

        case USER.OPEN_DIALOG_OVER_MAX_FILES:
            return { ...state, makeReturn: { ...state.makeReturn, dialogOverMaxFile: true } };

        case USER.CLOSE_DIALOG_OVER_MAX_FILES:
            return { ...state, makeReturn: { ...state.makeReturn, dialogOverMaxFile: false } };

        case USER.OPEN_DIALOG_SELECT_REMARK:
            return { ...state, makeReturn: { ...state.makeReturn, dialogSelectRemark: true } };

        case USER.CLOSE_DIALOG_SELECT_REMARK:
            return { ...state, makeReturn: { ...state.makeReturn, dialogSelectRemark: false } };

        case USER.OPEN_DIALOG_FILE_TYPE_NOT_SUPPORT:
            return { ...state, makeReturn: { ...state.makeReturn, dialogFileTypeNotSupport: true } };

        case USER.CLOSE_DIALOG_FILE_TYPE_NOT_SUPPORT:
            return { ...state, makeReturn: { ...state.makeReturn, dialogFileTypeNotSupport: false } };

        case USER.OPEN_DIALOG_FILE_REQUIRED:
            return { ...state, makeReturn: { ...state.makeReturn, dialogFileRequired: true } };

        case USER.CLOSE_DIALOG_FILE_REQUIRED:
            return { ...state, makeReturn: { ...state.makeReturn, dialogFileRequired: false } };

        case USER.OPEN_DIALOG_SUBMIT_ERROR:
            return { ...state, makeReturn: { ...state.makeReturn, dialogSubmitError: true } };

        case USER.CLOSE_DIALOG_SUBMIT_ERROR:
            return { ...state, makeReturn: { ...state.makeReturn, dialogSubmitError: false } };

        case USER.GET_VOUCHER_BY_USER_ID_PENDING:
            return { ...state, voucher: { ...state.voucher, isFetching: true } };
        case USER.GET_VOUCHER_BY_USER_ID_SUCCESS:
            return { ...state, voucher: { ...state.voucher, isFetching: false, data: payload } };
        case USER.GET_VOUCHER_BY_USER_ID_FAILED:
            return { ...state, voucher: { ...state.voucher, isFetching: false, error: true, dataError: payload } };
        
        case USER.VOUCHER_ORDER_FILTER_CHANGE:
            return { ...state, voucher: { ...state.voucher, filter: payload }}

        case USER.GET_PURCHASE_ORDER_BY_INVOICE_PENDING:
        case USER.GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE_PENDING:
            return { ...state, purchase: { ...state.purchase, isFetching: true, data: null, error: false, dataError: null } };
        case USER.GET_PURCHASE_ORDER_BY_INVOICE_SUCCESS:
        case USER.GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE_SUCCESS:
            return { ...state, purchase: { ...state.purchase, isFetching: false, data: payload } };
        case USER.GET_PURCHASE_ORDER_BY_INVOICE_FAILED:
        case USER.GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE_FAILED:
            return { ...state, purchase: { ...state.purchase, isFetching: false, error: true, dataError: error } };

        default:
            return state;
    }
};
